import HtmlTextarea from '@/components/ui/html-textarea.component.vue';
import { Options, Vue } from 'vue-class-component';
import { StrapLineConfig, StraplineContent } from '../../../../../common/src';
import store from '@/store';
import { sanitizeHtml } from '@/shared/utils';
import { Watch } from 'vue-property-decorator';
import { filterVisibleStraplines } from './use-straplines-bg-color';

@Options({
  components: {
    HtmlTextarea,
  },
})
export default class TheStrapLine extends Vue {
  items: Record<string, StrapLineConfig> = {};
  selectedLanguage: string | undefined = '';
  visibleItems: Record<string, { backgroundColor: string; straplineContent: StraplineContent }> = {};

  @Watch('$route.path', { immediate: true, deep: true })
  @Watch('$store.state.currentLocale.locale', { immediate: true, deep: true })
  @Watch('$store.state.user.status', { immediate: true, deep: true })
  refreshStrapLines(): void {
    this.selectedLanguage = store.state.currentLocale?.locale;
    this.visibleItems = this.filterStraplinesToShow();
  }

  created(): void {
    this.updateConfig();
  }

  @Watch('$store.state.config', { immediate: true, deep: true })
  private updateConfig(): void {
    this.items =
      (store.state.config?.strapLines?.htmlContents as Record<string, StrapLineConfig>) ?? /* istanbul ignore next @preserve */ {};
    this.visibleItems = this.filterStraplinesToShow();
  }

  private filterStraplinesToShow(): Record<string, { backgroundColor: string; straplineContent: StraplineContent }> {
    const visibleItems = filterVisibleStraplines(this.items, this.$route.path, this.selectedLanguage);

    for (const item of Object.values(visibleItems)) {
      item.straplineContent = {
        language: item.straplineContent.language,
        value: sanitizeHtml(item.straplineContent.value),
      };
    }

    return visibleItems;
  }

  get numberOfItems(): number {
    return Object.keys(this.visibleItems).length;
  }
}
